export default __webpack_public_path__ + "static/media/skins-header-bg3.175b966c.png";